import '../../style/components/logoWork.css'
export default function LogoWork(props) {
    return (
        <div className="bg-work" style={{
            backgroundImage:`url(${props.logo})`,
            width: props.width || "100%",
            height: props.height || "300px",
            backgroundSize: props.mode || "contain" 
        }}></div>
    )
}